const usePlanStore = defineStore("plan", () => {
  // state
  const plan = ref({
    id: null,
    nombre: null,
    descripcion: null,
    acumulable: false,
    beneficios: [],
    precios: [],
    orden: null,
    precio_pag_unitario: 0,
    plan_paypal_id: null,
  });

  const planes = ref([]);

  // getters

  const draft = computed(() => clone(plan.value));

  // mutations

  const setPlan = (payload) => {
    plan.value = payload;
  };

  const clear = () => {
    plan.value = {
      id: null,
      nombre: null,
      descripcion: null,
      beneficios: [],
      precios: [],
      acumulable: false,
      orden: null,
      precio_pag_unitario: 0,
      plan_paypal_id: null,
    };
  };

  const setPlanes = (payload) => (planes.value = payload);

  // actions
  const fetch = (plan_id) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/plans/${plan_id}/fetch-data`)
        .then(({ data }) => {
          setPlan(data);
          resolve(data);
        })
        .catch((e) => reject(e));
    });
  };

  const fetchData = (params) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`api/plans/fetch-data`, params)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((e) => reject(e));
    });
  };

  const guardar = (datos) => {
    return new Promise((resolve, reject) => {
      if (datos.id) {
        axios
          .put(`/api/plans/${datos.id}`, datos)
          .then(({ data }) => resolve(data))
          .catch((e) => reject(e));
      } else {
        axios
          .post(`/api/plans`, datos)
          .then(({ data }) => resolve(data))
          .catch((e) => reject(e));
      }
    });
  };

  const eliminar = (plan_id) => {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/plans/${plan_id}`)
        .then(({ data }) => resolve(data))
        .catch((e) => reject(e));
    });
  };

  const fetchPlanesSelect = async () => {
    try {
      const { data } = await axios.get(`/api/plans/fetch-list-select`);
      return data;
    } catch (error) {
      throw error;
    }
  };

  const getPrecioPagina = async (usuario_id) => {
    try {
      const { data } = await axios.get(
        `/api/plans/get-precio-pagina/${usuario_id}`
      );
      return data;
    } catch (error) {
      throw error;
    }
  };

  return {
    plan,
    draft,
    setPlan,
    setPlanes,
    fetch,
    clear,
    fetchData,
    guardar,
    eliminar,
    fetchPlanesSelect,
    getPrecioPagina,
  };
});

export default usePlanStore;
